import { cur } from '@/lib/currency';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Trash2, Edit2 } from 'lucide-react';
import { format } from 'date-fns';

const METHOD_LABELS = {
  'bank_transfer': 'Bank Transfer',
  'cheque': 'Cheque',
  'cash': 'Cash',
  'online_transfer': 'Online Transfer',
  'credit_card': 'Credit Card',
};

export function PaymentsTable({ payments, onDelete, onEdit }) {
  return (
    <Card>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr>
                <th className="text-left p-3">Date</th>
                <th className="text-left p-3">Platform</th>
                <th className="text-left p-3">Period</th>
                <th className="text-right p-3">Total Sales</th>
                <th className="text-right p-3">Commission</th>
                <th className="text-right p-3">Received</th>
                <th className="text-left p-3">Method</th>
                <th className="text-left p-3">Reference</th>
                <th className="text-right p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {payments.map(payment => (
                <tr key={payment.id} className="border-t hover:bg-muted/30">
                  <td className="p-3">{format(new Date(payment.payment_date), 'dd MMM yyyy')}</td>
                  <td className="p-3 font-medium">{payment.platform_name}</td>
                  <td className="p-3 text-muted-foreground text-xs">
                    {payment.period_start && payment.period_end
                      ? `${format(new Date(payment.period_start), 'dd MMM')} - ${format(new Date(payment.period_end), 'dd MMM')}`
                      : '-'}
                  </td>
                  <td className="p-3 text-right">{cur()} {(payment.total_sales || 0).toLocaleString()}</td>
                  <td className="p-3 text-right text-warning">{cur()} {(payment.commission_paid || 0).toLocaleString()}</td>
                  <td className="p-3 text-right font-bold text-success">{cur()} {(payment.amount_received || 0).toLocaleString()}</td>
                  <td className="p-3"><Badge variant="outline" className="text-xs">{METHOD_LABELS[payment.payment_method] || payment.payment_method || 'N/A'}</Badge></td>
                  <td className="p-3 text-xs text-muted-foreground font-mono">{payment.reference_number || '-'}</td>
                  <td className="p-3 text-right">
                    <div className="flex gap-1 justify-end">
                      {onEdit && (
                        <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-info hover:text-info hover:bg-info/10"
                          onClick={() => onEdit(payment)} data-testid={`edit-payment-${payment.id}`}>
                          <Edit2 size={14} />
                        </Button>
                      )}
                      <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-error hover:text-error hover:bg-error/10"
                        onClick={() => onDelete(payment.id)} data-testid={`delete-payment-${payment.id}`}>
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
              {payments.length === 0 && (
                <tr><td colSpan={9} className="p-8 text-center text-muted-foreground">No payments recorded yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
